import React from 'react';
import { FaArrowLeft} from 'react-icons/fa';

interface LeaveBreakoutRoomProps {
  onLeaveRoom: () => void;
}

const LeaveBreakoutRoom: React.FC<LeaveBreakoutRoomProps> = ({ onLeaveRoom }) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onLeaveRoom();
      }}
      className="px-4 py-2 bg-red-600 bg-opacity-80 text-white rounded-lg hover:bg-opacity-100 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg"
      title="Exit Breakout Room"
    >
      <FaArrowLeft size={16} />
     Exit Breakout Room
    </button>
  );
};

export default LeaveBreakoutRoom;

